// extracted by mini-css-extract-plugin
export default {"heading":"DeleteClassModalReasonStage_heading__lgwS3","sectionHeading":"DeleteClassModalReasonStage_sectionHeading__7pZRI"};